const createBackdrop = () => {
  let oSiteBackdrop;
  const tl = new TimelineLite();
  tl.timeScale(3);

  if (document.querySelector('.site-backdrop')) {
    oSiteBackdrop = document.querySelector('.site-backdrop');
  } else {
    oSiteBackdrop = document.body.appendChild(document.createElement('div'));
    oSiteBackdrop.classList.add('site-backdrop');
  }

  tl.set(oSiteBackdrop, { display: 'block' })
    .to(oSiteBackdrop, 1, { autoAlpha: 1 });

  return oSiteBackdrop;
};

const removeBackdrop = (oBackdrop) => {
  const tl = new TimelineLite();
  tl.timeScale(3);

  const destroyBackdrop = () => {
    oBackdrop.remove();
  };

  if (oBackdrop) {
    tl.to(oBackdrop, 1, { autoAlpha: 0 }, '-=1')
      .set(oBackdrop, { display: 'none', onComplete: destroyBackdrop });
  }
};
